const prefix = "analytics";

export const SAVE_DASHBOARD_DATA = `${prefix}/SET_DASHBOARD_DATA`;
export const SAVE_STUDY_ID = `${prefix}/SET_STUDY_ID`;
export const SAVE_SITES_DATA = `${prefix}/SET_SITES_DATA`;
export const SAVE_BENCHMARK_DATA = `${prefix}/SET_BENCHMARK_DATA`;
export const SAVE_ENROLLMENT_DATA = `${prefix}/SET_ENROLLMENT_DATA`;
export const SAVE_ECONSENT_UPLOADED_DATA = `${prefix}/SET_ECONSENT_UPLOADED_DATA`;
export const SAVE_TOP_SCREEN_FAIL_REASONS = `${prefix}/SET_TOP_SCREEN_FAIL_REASONS`;
export const SAVE_QUIZ_DATA = `${prefix}/SET_QUIZ_DATA`;
export const SAVE_RECRUITEMENT_DATA = `${prefix}/SET_RECRUITEMENT_DATA`;
export const SAVE_SENSOR_COMPLIANCE_DATA = `${prefix}/SET_SENSOR_COMPLIANCE_DATA`;
export const SAVE_OVERALL_COLLECTION_DATA = `${prefix}/SET_OVERALL_COLLECTION_DATA`;
export const SAVE_CANCELLED_TH_VISIT_DATA = `${prefix}/SET_CANCELLED_TH_VISIT_DATA`;
export const SAVE_COMPLIANCE_INSIGHT_SCORE = `${prefix}/SET_COMPLIANCE_INSIGHT_SCORE`;
export const SAVE_OVERALL_COLLECTION_MISSING_DATA = `${prefix}/SET_OVERALL_COLLECTION_MISSING_DATA`;
export const SAVE_NON_COMPLIENT_ACTIVITIES = `${prefix}/SET_NON_COMPLIENT_ACTIVITIES`;
export const SAVE_TH_VISITS_DURATION = `${prefix}/SET_TH_VISITS_DURATION`;
export const SAVE_COMPLIANCE_RATE_OVER_TIME = `${prefix}/SET_COMPLIANCE_RATE_OVER_TIME`;
export const SAVE_STUDY_COMPLIANCE_DATA = `${prefix}/SET_STUDY_COMPLIANCE_DATA`;
export const SAVE_STUDY_PARTICIPANT_COMPLIANCE_DATA = `${prefix}/SET_STUDY_PARTICIPANT_COMPLIANCE_DATA`;
export const SAVE_OVERALL_COLLECTION_PARTICIPANT_DATA = `${prefix}/SET_OVERALL_COLLECTION_PARTICIPANT_DATA`;
export const SAVE_GRAPHIC_COMPLIANCE_DATA = `${prefix}/SET_GRAPHIC_COMPLIANCE_DATA`;
export const SAVE_ANALYTICS_USER_DATA = `${prefix}/SET_ANALYTICS_USER_DATA`;
export const SAVE_DASHBOARD_REFRESH_DATA = `${prefix}/SET_DASHBOARD_REFRESH_DATA`;
export const SAVE_SITE_BY_ID_DATA = `${prefix}/SET_SITE_BY_ID_DATA`;
export const SAVE_ALL_ENROLLMENT_DATA = `${prefix}/SET_ALL_ENROLLMENT_DATA`;

export default prefix;
